/* Motomox quantity stepper.
   - Caps the quantity at the selected variant's stock minus what is already in the cart
     (stock comes from the JSON printed by snippets/motomox-stock-indicator.liquid).
   - Leaves the theme's own add-to-cart request untouched (apps hook into it), but undoes
     the theme's "View cart" flip afterwards so the Add to Cart button stays usable, and
     shows a short confirmation line with a View cart link instead.
   - Variant changes, cart changes in other tabs and partial-add errors all re-sync. */
(function () {
  'use strict';
  if (window.MoxQtyStepper) { return; }
  window.MoxQtyStepper = true;

  var HARD_MAX = 99;
  var cart = null;

  function sectionOf(el) { return el.closest('[data-section-id]') || document; }

  function stockData(form) {
    var s = sectionOf(form).querySelector('[data-mox-stock-data]');
    if (!s) { return null; }
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  function sameOptions(a, b) {
    if (!a || !b || a.length !== b.length) { return false; }
    for (var i = 0; i < a.length; i++) { if (String(a[i]) !== String(b[i])) { return false; } }
    return true;
  }

  function selectedVariantId(form, data) {
    var selectors = form.querySelectorAll('.single-option-selector');
    if (selectors.length && data) {
      var chosen = [];
      for (var i = 0; i < selectors.length; i++) { chosen.push(selectors[i].value); }
      for (var id in data) {
        if (Object.prototype.hasOwnProperty.call(data, id) && sameOptions(data[id].o, chosen)) { return id; }
      }
      return null;
    }
    var master = form.querySelector('select[name="id"], input[name="id"]');
    return master && master.value ? master.value : null;
  }

  function inCart(id) {
    if (!cart || !cart.items) { return 0; }
    var n = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].variant_id) === String(id)) { n += cart.items[i].quantity; }
    }
    return n;
  }

  function limits(form) {
    var data = stockData(form);
    var id = selectedVariantId(form, data);
    var info = data && id ? data[id] : null;
    var lim = { id: id, max: HARD_MAX, tracked: false, stock: null, carted: id ? inCart(id) : 0, available: true, known: !!info };
    if (!info) { return lim; }
    lim.available = !!info.a;
    if (!info.a) { lim.max = 0; return lim; }
    if (info.t) {
      lim.tracked = true;
      lim.stock = info.q;
      lim.max = Math.max(0, info.q - lim.carted);
    }
    return lim;
  }

  function cartUrl(form) {
    var btn = form.querySelector('#AddToCart, .product-single__cart-submit');
    return (btn && btn.getAttribute('data-cart-url')) || '/cart';
  }

  function setNote(form, html, kind) {
    var n = form.querySelector('[data-mox-qty-note]');
    if (!n) {
      n = document.createElement('p');
      n.setAttribute('data-mox-qty-note', '');
      n.setAttribute('aria-live', 'polite');
      var w = form.querySelector('.product-single__cart-submit-wrapper');
      (w || form).insertAdjacentElement('afterend', n);
    }
    n.className = 'mox-qty__note' + (kind ? ' mox-qty__note--' + kind : '');
    n.innerHTML = html || '';
    n.hidden = !html;
  }

  function viewCartLink(form) {
    return '<a href="' + cartUrl(form) + '">View cart</a>';
  }

  // Show a small "each" after the price whenever more than one is selected, so the price
  // is clearly per item. Inserted as a sibling of the price element because the theme
  // rewrites the price element's contents on variant changes.
  function setEach(form, show) {
    var price = sectionOf(form).querySelector('#ProductPrice, .product-single__price');
    if (!price) { return; }
    var each = price.parentNode.querySelector('[data-mox-each]');
    if (!each) {
      each = document.createElement('span');
      each.className = 'mox-qty__each';
      each.setAttribute('data-mox-each', '');
      each.textContent = 'each';
      price.insertAdjacentElement('afterend', each);
    }
    each.hidden = !show;
  }

  function statusNote(form, lim, added) {
    var sep = '<span class="mox-qty__sep">&middot;</span>';
    if (lim.available && lim.tracked && lim.max < 1 && lim.carted > 0) {
      return { html: 'All ' + lim.stock + ' in stock are in your cart' + sep + viewCartLink(form), kind: added ? 'ok' : '' };
    }
    if (added) {
      return { html: '&#10003; ' + added + ' added to cart' + sep + lim.carted + ' in your cart' + sep + viewCartLink(form), kind: 'ok' };
    }
    if (lim.carted > 0) {
      return { html: lim.carted + ' in your cart' + sep + viewCartLink(form), kind: '' };
    }
    return { html: '', kind: '' };
  }

  function refresh(form, added) {
    var box = form.querySelector('[data-mox-qty]');
    if (!box) { return; }
    var input = box.querySelector('[data-mox-qty-input]');
    var dec = box.querySelector('[data-mox-qty-dec]');
    var inc = box.querySelector('[data-mox-qty-inc]');
    var btn = form.querySelector('#AddToCart, .product-single__cart-submit');
    var lim = limits(form);
    var qty = parseInt(input.value, 10);
    if (!(qty >= 1)) { qty = 1; }
    if (lim.max >= 1 && qty > lim.max) { qty = lim.max; }
    if (lim.max < 1) { qty = 1; }
    input.value = qty;
    input.max = lim.max >= 1 ? lim.max : 1;
    dec.disabled = qty <= 1 || lim.max < 1;
    inc.disabled = lim.max < 1 || qty >= lim.max;
    box.classList.toggle('is-disabled', lim.max < 1);
    setEach(form, qty > 1);
    if (btn) {
      if (lim.available && lim.tracked && lim.max < 1) {
        btn.disabled = true;
        btn.setAttribute('data-mox-blocked', '1');
      } else if (btn.getAttribute('data-mox-blocked')) {
        btn.disabled = false;
        btn.removeAttribute('data-mox-blocked');
      }
    }
    var n = statusNote(form, lim, added);
    setNote(form, n.html, n.kind);
  }

  function refreshAll(added) {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) { if (forms[i].querySelector('[data-mox-qty]')) { refresh(forms[i], added); } }
  }

  function loadCart() {
    return new Promise(function (resolve) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/cart.js?t=' + Date.now(), true);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try { cart = JSON.parse(xhr.responseText); } catch (e) { /* keep old cart */ }
        }
        resolve(cart);
      };
      xhr.onerror = function () { resolve(cart); };
      xhr.send();
    });
  }

  // --- Undo the theme's "View cart" flip and its error markup after an add-to-cart ---
  function unflip(form, addedQty) {
    var btn = form.querySelector('#AddToCart, .product-single__cart-submit');
    var i, els;
    els = form.querySelectorAll('.product-single__notification, .btn--view-cart');
    for (i = 0; i < els.length; i++) { els[i].parentNode.removeChild(els[i]); }
    if (btn) {
      btn.classList.remove('btn--unflipped');
      btn.style.display = '';
    }
    loadCart().then(function () {
      var input = form.querySelector('[data-mox-qty-input]');
      if (input) { input.value = 1; }
      refresh(form, addedQty);
      if (window.theme && typeof window.theme.afterCartLoad === 'function') { window.theme.afterCartLoad(); }
    });
  }

  function handleError(form, errorEl) {
    var msg = errorEl.textContent.trim() || 'Sorry, that could not be added to the cart.';
    errorEl.parentNode.removeChild(errorEl);
    var btn = form.querySelector('#AddToCart, .product-single__cart-submit');
    var txt = btn && btn.querySelector('#AddToCartText');
    if (btn) {
      btn.disabled = false;
      btn.classList.remove('btn--ajax-disabled');
      var original = btn.getAttribute('data-mox-label');
      if (txt && original) { txt.textContent = original; }
    }
    loadCart().then(function () {
      refresh(form);
      setNote(form, msg + '<span class="mox-qty__sep">&middot;</span>' + viewCartLink(form), 'warn');
    });
  }

  var watched = [];

  function watch(form) {
    if (form.getAttribute('data-mox-qty-watched')) { return; }
    form.setAttribute('data-mox-qty-watched', '1');
    var btn = form.querySelector('#AddToCart, .product-single__cart-submit');
    var txt = btn && btn.querySelector('#AddToCartText');
    if (btn && txt) { btn.setAttribute('data-mox-label', txt.textContent.trim()); }
    var state = { form: form, pendingQty: 1, clickedAt: 0, handledAt: 0 };
    watched.push(state);
    state.arm = function () {
      state.pendingQty = parseInt(form.querySelector('[data-mox-qty-input]').value, 10) || 1;
      state.clickedAt = Date.now();
    };
    var mo = new MutationObserver(function (records) {
      for (var r = 0; r < records.length; r++) {
        var added = records[r].addedNodes;
        for (var i = 0; i < added.length; i++) {
          var node = added[i];
          if (node.nodeType !== 1) { continue; }
          if (node.classList.contains('btn--view-cart')) { state.handledAt = Date.now(); unflip(form, state.pendingQty); return; }
          if (node.classList.contains('errors')) { state.handledAt = Date.now(); handleError(form, node); return; }
        }
      }
    });
    mo.observe(form, { childList: true, subtree: true });
  }

  // Record the quantity the shopper asked for the moment they press Add to Cart. Listening on
  // window (capture phase) runs before any app that stops the click on its way to the button.
  function armFor(target) {
    var btn = target && target.closest ? target.closest('#AddToCart, .product-single__cart-submit') : null;
    var form = btn && btn.closest('form');
    if (!form) { return; }
    for (var i = 0; i < watched.length; i++) { if (watched[i].form === form) { watched[i].arm(); } }
  }
  window.addEventListener('click', function (e) { armFor(e.target); }, true);
  window.addEventListener('submit', function (e) {
    var form = e.target;
    for (var i = 0; i < watched.length; i++) { if (watched[i].form === form) { watched[i].arm(); } }
  }, true);

  // Some apps (e.g. the add-ons app) send the add-to-cart request themselves and the theme
  // never shows its flip. Watch cart "add" requests directly so the confirmation still appears.
  function onCartAddRequest() {
    var now = Date.now();
    for (var i = 0; i < watched.length; i++) {
      var s = watched[i];
      if (s.clickedAt && now - s.clickedAt < 15000 && s.handledAt < s.clickedAt) {
        s.handledAt = now;
        (function (st) { setTimeout(function () { unflip(st.form, st.pendingQty); }, 400); })(s);
      }
    }
  }

  function isCartAdd(url) {
    return url && /\/cart\/add(\.js)?(\?|$)/.test(String(url).replace(/^https?:\/\/[^/]+/, ''));
  }

  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var p = origFetch.apply(this, arguments);
      if (isCartAdd(url)) { p.then(function (res) { if (res && res.ok) { onCartAddRequest(); } }, function () {}); }
      return p;
    };
  }
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartAdd(url)) {
      this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) { onCartAddRequest(); } });
    }
    return origOpen.apply(this, arguments);
  };

  // --- Events ---
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-mox-qty-dec], [data-mox-qty-inc]') : null;
    if (!t) { return; }
    e.preventDefault();
    var form = t.closest('form');
    var input = form.querySelector('[data-mox-qty-input]');
    var qty = parseInt(input.value, 10) || 1;
    input.value = t.hasAttribute('data-mox-qty-inc') ? qty + 1 : qty - 1;
    refresh(form);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches) { return; }
    if (t.matches('[data-mox-qty-input]')) { refresh(t.closest('form')); return; }
    if (t.matches('.single-option-selector, select[name="id"], input[name="id"]')) {
      var form = t.closest('form');
      if (form) { setTimeout(function () { refresh(form); }, 0); }
    }
  }, true);

  if (window.jQuery) {
    window.jQuery(document).on('change', '.single-option-selector, select[name="id"], input[name="id"]', function () {
      var form = this.closest('form');
      if (form) { setTimeout(function () { refresh(form); }, 0); }
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') { loadCart().then(function () { refreshAll(); }); }
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { loadCart().then(function () { refreshAll(); }); } });

  function init() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) { if (forms[i].querySelector('[data-mox-qty]')) { watch(forms[i]); } }
    loadCart().then(function () { refreshAll(); });
    // The theme builds its option selectors shortly after load; re-check once they exist
    window.addEventListener('load', function () { setTimeout(function () { refreshAll(); }, 300); });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
